import { render } from "./BarChartIcon.vue?vue&type=template&id=1f7d4ee0&scoped=true"
import script from "./BarChartIcon.vue?vue&type=script&lang=js"
export * from "./BarChartIcon.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildagent/work/4109ecccb628e132/monorepo_migration/wijmo-sample/reference-samples/config/vue3/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f7d4ee0"]])

export default __exports__